import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App, {AffiniOptions} from './App';
import './index.css';

const options: AffiniOptions[] = window['affinipay_options'];

if (Array.isArray(options)) {
  for (const [index, option] of options.entries()) {
    const appContainer = document.createElement("div")
    const id = `apPayment${index}`
    appContainer.id = id

    const entryContent = document.getElementById('root');
    if( entryContent !== null) {
      entryContent.appendChild(appContainer)
    } else {
      throw new Error('The root node was not found! Plugin expects an existing div element with an id of "root"')
    }

    ReactDOM.render(
      <App {...option} index={index}/>,
      document.getElementById(id) as HTMLElement
    )
  }
} else {
  ReactDOM.render(
    <App {...options}/>,
    document.getElementById('root') as HTMLElement
  )
}



// WEBPACK FOOTER //
// ./src/index.tsx